import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BaseClient } from '../BaseClient';
export class SiteMediaFilesClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "generateFileUploadUrlImpl", void 0);
  }
  async generateFileUploadUrl(mimeType, fileName) {
    if (mimeType === void 0) {
      mimeType = 'image/jpeg';
    }
    if (fileName === void 0) {
      fileName = 'image.jpg';
    }
    try {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }
      const {
        uploadUrl
      } = await this.request(this.generateFileUploadUrlImpl({
        mimeType,
        fileName,
        filePath: '/_schedulingAssistant'
      }), ...args);
      if (!uploadUrl) {
        throw new Error('failed to generate file upload url');
      }
      return uploadUrl;
    } catch (error) {
      this.logError('generateFileUploadUrl', 'Failed to generate file upload URL', {}, error);
      throw error;
    }
  }
  convertToEntity() {
    throw new Error('convertToEntity method should not be used in this context');
  }
  getServiceNameForLogs() {
    return 'SiteMediaFilesClient';
  }
}
//# sourceMappingURL=SiteMediaFilesClientBase.js.map